import { createFileRoute } from "@tanstack/react-router";

import { ComingSoon } from "../../../components/stubs/ComingSoon";

export const Route = createFileRoute("/_authed/super/debugging")({
  component: SuperDebuggingPage,
  head: () => ({
    meta: [{ title: "Debugging | NBDC" }],
  }),
});

function SuperDebuggingPage() {
  return <ComingSoon title="Debugging" />;
}
